// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainTitleRmSb {
  margin-top: 15px;
  font-family: "MontserratSemiBold", sans-serif;
  font-size: 22px; /** h1 usual is 28px */
}

.noScroll {
  overflow: hidden;
}

.buttonTitle {
  padding-right: 10px;
  margin-top: 2px;
}

.icon-inline {
  display: inline-block !important; /* override any block defaults */
  vertical-align: top !important; /* center it on the text */
  margin-right: 0.3em; /* a little breathing room */
}

.button {
  margin-top: 10px;
  padding: 10px;
  color: white;
  width: calc(50% - 5px);
  text-align: center;
  background: #666;
  cursor: pointer;
}
.button.btn-using-wbi {
  width: -moz-fit-content;
  width: fit-content;
  padding: 10px 16px;
}

.button:hover {
  background: #777;
  cursor: pointer;
}

.titleRight {
  padding-left: 10px;
  margin-top: 2px;
  color: #444;
}

#reportPopUp {
  position: fixed;
  z-index: 10000;
  background-color: white;
  border: 4px solid #dddddd;
  top: 25px;
  bottom: 25px;
  right: 150px;
}

/* When showing the WBI popup, size to content and center */
#reportPopUp.new-ibt-popup {
  top: 50%;
  left: 50%;
  bottom: auto;
  right: auto;
  transform: translate(-50%, -50%);
  height: auto;
  max-height: calc(100vh - 50px);
  overflow-y: auto;
  overflow-x: hidden;
}

.smallTxt {
  font-size: 93%;
}

.first, .second, .third {
  width: 33.3333333333%;
  float: left;
}

.first {
  padding: 0px 5px 5px 0px;
}

.second {
  padding: 0px 5px 5px 5px;
}

.third {
  padding: 0px 0px 5px 5px;
}

.cardSpacer {
  height: 10px;
}

#legend {
  margin-top: 5px;
  margin-bottom: 5px;
  border-collapse: separate;
  border-spacing: 0 2px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
#legend .adaptation-level-flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
}
#legend .adaptation-level-flex td {
  padding-bottom: 5px;
}
#legend tr {
  background-color: #eee;
}

#legend tr td:first-child {
  padding-right: 10px;
  padding-left: 10px;
}

#legend tr td:nth-child(3), #legend tr td:nth-child(5), #legend tr td:nth-child(7), #legend tr td:nth-child(9) {
  padding-top: 7px;
}

#legend tr td:nth-child(2), #legend tr td:nth-child(4), #legend tr td:nth-child(6), #legend tr td:nth-child(8) {
  padding-top: 5px;
}

#legend tr td:nth-child(3), #legend tr td:nth-child(5), #legend tr td:nth-child(7) {
  width: 60px;
  padding: 4px;
}

#legend tr:nth-child(2) td:nth-child(2), #legend tr:nth-child(2) td:nth-child(4), #legend tr:nth-child(2) td:nth-child(6) {
  padding-left: 3px;
}

#legend tr td:nth-child(9) {
  width: 70px;
  padding: 4px;
}

.headerList {
  width: 100%;
  background-color: #666;
  color: white;
  padding: 10px;
  font-size: 18px;
  font-weight: bold;
  margin: 5px auto;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/jobSatisfactions/components/web/job-satisfactions-report/job-satisfactions-report.component.scss"],"names":[],"mappings":"AAEA;EACI,gBAAA;EACA,6CAAA;EACA,eAAA,EAAA,sBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,mBAAA;EACA,eAAA;AADJ;;AAIA;EACI,gCAAA,EAAA,gCAAA;EACA,8BAAA,EAAA,0BAAA;EACA,mBAAA,EAAA,4BAAA;AADJ;;AAIA;EACI,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AADJ;AAEI;EACI,uBAAA;EAAA,kBAAA;EACA,kBAAA;AAAR;;AAIA;EACI,gBAAA;EACA,eAAA;AADJ;;AAKA;EACI,kBAAA;EACA,eAAA;EACA,WAAA;AAFJ;;AAKA;EACI,eAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;AAFJ;;AAIA,2DAAA;AACA;EACI,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAGA;EACI,qBAAA;EACA,WAAA;AAAJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,eAAA;EACA,kBAAA;EACD,yBAAA;EACC,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACJ;AAAI;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;AAER;AADQ;EAEI,mBAAA;AAEZ;AASA;EACI,sBAAA;AAPJ;;AAUA;EACI,mBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,gBAAA;AAPJ;;AAUA;EACI,gBAAA;AAPJ;;AAUA;EACI,WAAA;EACA,YAAA;AAPJ;;AAUA;EACI,iBAAA;AAPJ;;AAUA;EACI,WAAA;EACA,YAAA;AAPJ;;AAUA;EACI,WAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAPJ","sourcesContent":["\n\n.mainTitleRmSb {\n    margin-top: 15px;\n    font-family: 'MontserratSemiBold',  sans-serif;\n    font-size: 22px; /** h1 usual is 28px */\n}\n\n.noScroll {\n    overflow: hidden;\n}\n\n.buttonTitle {\n    padding-right: 10px;\n    margin-top: 2px;\n}\n\n.icon-inline {\n    display: inline-block !important;   /* override any block defaults */\n    vertical-align: top !important;   /* center it on the text */\n    margin-right: 0.3em;                 /* a little breathing room */\n}\n\n.button {\n    margin-top: 10px;\n    padding: 10px;\n    color: white;\n    width: calc(50% - 5px);\n    text-align: center;\n    background: #666;\n    cursor: pointer;\n    &.btn-using-wbi {\n        width: fit-content;\n        padding: 10px 16px;\n    }\n}\n\n.button:hover {\n    background: #777;\n    cursor: pointer;\n}\n\n\n.titleRight {\n    padding-left: 10px;\n    margin-top: 2px;\n    color: #444;\n}\n\n#reportPopUp {\n    position: fixed;\n    z-index: 10000;\n    background-color: white;\n    border: 4px solid #dddddd;\n    top: 25px;\n    bottom: 25px;\n    right: 150px;\n}\n/* When showing the WBI popup, size to content and center */\n#reportPopUp.new-ibt-popup {\n    top: 50%;\n    left: 50%;\n    bottom: auto;\n    right: auto;\n    transform: translate(-50%, -50%);\n    height: auto;\n    max-height: calc(100vh - 50px);\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.smallTxt {\n    font-size: 93%;\n}\n.first, .second, .third {\n    width: 33.3333333333%;\n    float: left;\n}\n.first {\n    padding: 0px 5px 5px 0px;\n}\n\n.second {\n    padding: 0px 5px 5px 5px;\n}\n\n.third {\n    padding: 0px 0px 5px 5px;\n}\n\n.cardSpacer {\n    height: 10px;\n}\n\n#legend {\n    margin-top: 5px;\n    margin-bottom: 5px;\n   border-collapse: separate;\n    border-spacing: 0 2px;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    .adaptation-level-flex {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        gap: 5px;\n        td {\n            // width: unset!important;\n            padding-bottom: 5px;\n            // padding-right: 10px!important;\n            img {\n                \n            }\n           \n        }\n    \n}\n}\n\n#legend tr {\n    background-color: #eee;\n}\n\n#legend tr td:first-child {\n    padding-right: 10px;\n    padding-left: 10px;\n}\n\n#legend tr td:nth-child(3), #legend tr td:nth-child(5), #legend tr td:nth-child(7), #legend tr td:nth-child(9) {\n    padding-top: 7px;\n}\n\n#legend tr td:nth-child(2), #legend tr td:nth-child(4), #legend tr td:nth-child(6), #legend tr td:nth-child(8) {\n    padding-top: 5px;\n}\n\n#legend tr td:nth-child(3), #legend tr td:nth-child(5), #legend tr td:nth-child(7) {\n    width: 60px;\n    padding: 4px;\n}\n\n#legend tr:nth-child(2) td:nth-child(2), #legend tr:nth-child(2) td:nth-child(4), #legend tr:nth-child(2) td:nth-child(6) {\n    padding-left: 3px;\n}\n\n#legend tr td:nth-child(9) {\n    width: 70px;\n    padding: 4px;\n}\n\n.headerList {\n    width: 100%;\n    background-color: #666;\n    color: white;\n    padding: 10px;\n    font-size: 18px;\n    font-weight: bold;\n    margin: 5px auto;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
